export default __webpack_public_path__ + "18ecab8fe534edef66d727f96ddc930b.png";